const menu = [
    {
        id: 1,
        category: '아이스크림',
        name: '싱글레귤러 (콘 / 컵)',
        price: 3900,
        img: process.env.PUBLIC_URL + '/images/single.png',
        flavor: 1,
    },
    {
        id: 2,
        category: '아이스크림',
        name: '싱글킹 (콘 / 컵)',
        price: 4700,
        img: process.env.PUBLIC_URL + '/images/single.png',
        flavor: 1,
    },
    {
        id: 3,
        category: '아이스크림',
        name: '더블주니어 (콘 / 컵)',
        price: 5100,
        img: process.env.PUBLIC_URL + '/images/double.png',
        flavor: 2,
    },
    {
        id: 4,
        category: '아이스크림',
        name: '더블레귤러 (콘 / 컵)',
        price: 7300,
        img: process.env.PUBLIC_URL + '/images/double.png',
        flavor: 2,
    },
    {
        id: 5,
        category: '아이스크림',
        name: '파인트 (3가지맛)',
        price: 9800,
        img: process.env.PUBLIC_URL + '/images/pint.png',
        option: '컵',
        flavor: 3,
    },
    {
        id: 6,
        category: '아이스크림',
        name: '쿼터 (4가지맛)',
        price: 18500,
        img: process.env.PUBLIC_URL + '/images/quart.png',
        option: '컵',
        flavor: 4,
    },
    {
        id: 7,
        category: '아이스크림',
        name: '패밀리 (5가지맛)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/family.png',
        option: '컵',
        flavor: 5,
    },
    {
        id: 8,
        category: '아이스크림',
        name: '하프갤론 (6가지맛)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/half_gallon.png',
        option: '컵',
        flavor: 6,
    },
    {
        id: 9,
        category: '아이스크림',
        name: '버라이어티팩 (싱글레귤러 6개)',
        price: 23400,
        img: process.env.PUBLIC_URL + '/images/variety_pack.png',
        option: '컵',
        flavor: 6,
    },
    {
        id: 10,
        category: '아이스크림',
        name: '핸드팩 (파인트 4개)',
        price: 39200,
        img: process.env.PUBLIC_URL + '/images/hand_pack.png',
        option: '컵',
        flavor: 4,
    },
    {
        id: 11,
        category: '아이스크림 케이크',
        name: '더 듬뿍 딸기 우유 케이크',
        price: 35000,
        img: process.env.PUBLIC_URL + '/images/cake01.png',
    },
    {
        id: 12,
        category: '아이스크림 케이크',
        name: '스트로베리 초코 바스켓',
        price: 36000,
        img: process.env.PUBLIC_URL + '/images/cake02.png',
    },
    {
        id: 13,
        category: '아이스크림 케이크',
        name: '스윗 해피 트레인',
        price: 34000,
        img: process.env.PUBLIC_URL + '/images/cake03.png',
    },
    {
        id: 14,
        category: '아이스크림 케이크',
        name: '초코 볼 눌',
        price: 11000,
        img: process.env.PUBLIC_URL + '/images/cake04.png',
    },
    {
        id: 15,
        category: '아이스크림 케이크',
        name: '럭키 포니 춘식이',
        price: 30000,
        img: process.env.PUBLIC_URL + '/images/cake05.png',
    },
    {
        id: 16,
        category: '아이스크림 케이크',
        name: '해-삐 잔망 루피',
        price: 33000,
        img: process.env.PUBLIC_URL + '/images/cake06.png',
    },
    {
        id: 17,
        category: '아이스크림 케이크',
        name: '스트로베리 요거트 프레지에',
        price: 49000,
        img: process.env.PUBLIC_URL + '/images/cake07.png',
    },
    {
        id: 18,
        category: '아이스크림 케이크',
        name: '베스트 콤비, 닉 앤 주디',
        price: 32000,
        img: process.env.PUBLIC_URL + '/images/cake08.png',
    },
    {
        id: 19,
        category: '아이스크림 케이크',
        name: '스윗 하트 큐피드',
        price: 34000,
        img: process.env.PUBLIC_URL + '/images/cake09.png',
    },
    {
        id: 20,
        category: '아이스크림 케이크',
        name: '윈터 밤 스노우 포레스트',
        price: 34000,
        img: process.env.PUBLIC_URL + '/images/cake10.png',
    },
        {
        id: 21,
        category: '아이스크림 케이크',
        name: '핑크 래빗 에그',
        price: 11000,
        img: process.env.PUBLIC_URL + '/images/cake11.png',
    },
    {
        id: 22,
        category: '아이스크림 케이크',
        name: '스윗 레드 하트',
        price: 27000,
        img: process.env.PUBLIC_URL + '/images/cake12.png',
    },
    {
        id: 23,
        category: '아이스크림 케이크',
        name: '초콜릿 앤 카라멜 몽블랑',
        price: 33000,
        img: process.env.PUBLIC_URL + '/images/cake13.png',
    },
    {
        id: 24,
        category: '아이스크림 케이크',
        name: '두바이 스타일 앤 스트로베리',
        price: 42000,
        img: process.env.PUBLIC_URL + '/images/cake14.png',
    },
    {
        id: 25,
        category: '아이스크림 케이크',
        name: '골든 브륄레 판타지',
        price: 32000,
        img: process.env.PUBLIC_URL + '/images/cake15.png',
    },
    {
        id: 26,
        category: '아이스크림 케이크',
        name: '미니 골라먹는 와츄원',
        price: 19000,
        img: process.env.PUBLIC_URL + '/images/cake16.png',
    },
    {
        id: 27,
        category: '아이스크림 케이크',
        name: '진정한 초콜릿 컬렉션',
        price: 30000,
        img: process.env.PUBLIC_URL + '/images/cake17.png',
    },
    {
        id: 28,
        category: '아이스크림 케이크',
        name: '더 듬뿍 오렌지 앤 자몽 케이크',
        price: 34000,
        img: process.env.PUBLIC_URL + '/images/cake18.png',
    },
    {
        id: 29,
        category: '아이스크림 케이크',
        name: '더 듬뿍 프루티 케이크',
        price: 34000,
        img: process.env.PUBLIC_URL + '/images/cake19.png',
    },
    {
        id: 30,
        category: '아이스크림 케이크',
        name: '(Lessly Edition) 엄마는 외계인 미니 케이크',
        price: 22000,
        img: process.env.PUBLIC_URL + '/images/cake20.png',
    },
    {
        id: 31,
        category: '아이스크림 케이크',
        name: '베리 베리 에그',
        price: 11000,
        img: process.env.PUBLIC_URL + '/images/cake21.png',
    },
    {
        id: 32,
        category: '아이스크림 케이크',
        name: '골라먹는 27 큐브',
        price: 29000,
        img: process.env.PUBLIC_URL + '/images/cake22.png',
    },
    {
        id: 33,
        category: '아이스크림 케이크',
        name: '미니 해피 버스데이 케이크',
        price: 19000,
        img: process.env.PUBLIC_URL + '/images/cake23.png',
    },
    {
        id: 34,
        category: '아이스크림 케이크',
        name: '우주에서 온 엄마는 외계인',
        price: 28000,
        img: process.env.PUBLIC_URL + '/images/cake24.png',
    },
    {
        id: 35,
        category: '아이스크림 케이크',
        name: '한교동의 스윗 파티',
        price: 30000,
        img: process.env.PUBLIC_URL + '/images/cake25.png',
    },
    {
        id: 36,
        category: '아이스크림 케이크',
        name: '진정한 티라미수 컬렉션',
        price: 28000,
        img: process.env.PUBLIC_URL + '/images/cake26.png',
    },
    {
        id: 37,
        category: '아이스크림 케이크',
        name: '골든 프랄린 버터 케이크',
        price: 21000,
        img: process.env.PUBLIC_URL + '/images/cake27.png',
    },
    {
        id: 38,
        category: '아이스크림 케이크',
        name: '스노우 볼 와츄원',
        price: 29000,
        img: process.env.PUBLIC_URL + '/images/cake28.png',
    },
    {
        id: 39,
        category: '아이스크림 케이크',
        name: '(Lessly Edition) 아몬드 봉봉 미니 케이크',
        price: 22000,
        img: process.env.PUBLIC_URL + '/images/cake29.png',
    },
    {
        id: 40,
        category: '아이스크림 케이크',
        name: '마법에 걸린 달콤한 사과',
        price: 11000,
        img: process.env.PUBLIC_URL + '/images/cake30.png',
    },
    {
        id: 41,
        category: '아이스크림 케이크',
        name: '백설공주의 황금 드레스',
        price: 11000,
        img: process.env.PUBLIC_URL + '/images/cake31.png',
    },
    {
        id: 42,
        category: '아이스크림 케이크',
        name: '리얼 초코 27 큐브',
        price: 29000,
        img: process.env.PUBLIC_URL + '/images/cake32.png',
    },
    {
        id: 43,
        category: '아이스크림 케이크',
        name: '마이멜로디와 더 듬뿍 딸기',
        price: 34000,
        img: process.env.PUBLIC_URL + '/images/cake33.png',
    },
    {
        id: 44,
        category: '프리팩',
        name: '블록팩 민트초코봉봉',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack01.png',
    },
    {
        id: 45,
        category: '프리팩',
        name: '애플망고 젤라또',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/pack02.png',
    },
    {
        id: 46,
        category: '프리팩',
        name: '블록팩 바람과함께사라지다',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack03.png',
    },
    {
        id: 47,
        category: '프리팩',
        name: '(Lessly Edition) 블록팩 초코나무 숲',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack04.png',
    },
    {
        id: 48,
        category: '프리팩',
        name: '(Lessly Edition) 블록팩 엄마는 외계인',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack05.png',
    },
    {
        id: 49,
        category: '프리팩',
        name: '블록팩 초콜릿',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack06.png',
    },
    {
        id: 50,
        category: '프리팩',
        name: '요거트 젤라또',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/pack07.png',
    },
        {
        id: 51,
        category: '프리팩',
        name: '블록팩 이상한나라의솜사탕',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack08.png',
    },
    {
        id: 52,
        category: '프리팩',
        name: '(Lessly Edition) 블록팩 민트 초콜릿 칩',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack09.png',
    },
    {
        id: 53,
        category: '프리팩',
        name: '(Lessly Edition) 블록팩 아몬드 봉봉',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack10.png',
    },
    {
        id: 54,
        category: '프리팩',
        name: '블록팩 뉴욕치즈케이크',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack11.png',
    },
    {
        id: 55,
        category: '프리팩',
        name: '블록팩 엄마는외계인',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack12.png',
    },
    {
        id: 56,
        category: '프리팩',
        name: '블록팩 레인보우샤베트',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack13.png',
    },
    {
        id: 57,
        category: '프리팩',
        name: '블록팩 베리베리스트로베리',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack14.png',
    },
    {
        id: 58,
        category: '프리팩',
        name: '레디팩 (엄마는 외계인)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/pack15.png',
    },
    {
        id: 59,
        category: '프리팩',
        name: '레디팩 (레인보우 샤베트)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/pack16.png',
    },
    {
        id: 60,
        category: '프리팩',
        name: '블록팩 슈팅스타',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack17.png',
    },
    {
        id: 61,
        category: '프리팩',
        name: '블록팩 체리쥬빌레',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack18.png',
    },
    {
        id: 62,
        category: '프리팩',
        name: '레디팩 (31 요거트)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/pack19.png',
    },
    {
        id: 63,
        category: '프리팩',
        name: '블록팩 쿠키앤크림',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack20.png',
    },
    {
        id: 64,
        category: '프리팩',
        name: '레디팩 (민트 초콜릿 칩)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/pack21.png',
    },
    {
        id: 65,
        category: '프리팩',
        name: '레디팩 (아몬드 봉봉)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/pack22.png',
    },
    {
        id: 66,
        category: '프리팩',
        name: '레디팩 (소금 우유)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/pack23.png',
    },
    {
        id: 67,
        category: '프리팩',
        name: '레디팩 (오레오 쿠키 앤 크림)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/pack24.png',
    },
    {
        id: 68,
        category: '프리팩',
        name: '블록팩 아몬드봉봉',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/pack25.png',
    },
    {
        id: 69,
        category: '프리팩',
        name: '레디팩 (초코나무 숲)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/pack26.png',
    },
    {
        id: 70,
        category: '프리팩',
        name: '레디팩 (베리베리 스트로베리)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/pack27.png',
    },
    {
        id: 71,
        category: '프리팩',
        name: '레디팩 (체리쥬빌레)',
        price: 10800,
        img: process.env.PUBLIC_URL + '/images/pack28.png',
    },
    {
        id: 72,
        category: '디저트',
        name: '아이스 바움쿠헨 아몬드봉봉',
        price: 4500,
        img: process.env.PUBLIC_URL + '/images/dessert01.png',
    },
    {
        id: 73,
        category: '디저트',
        name: '아이스 찹쌀 한과 조청',
        price: 6800,
        img: process.env.PUBLIC_URL + '/images/dessert02.png',
    },
    {
        id: 74,
        category: '디저트',
        name: '아이스 마카롱 초콜릿 무스',
        price: 3800,
        img: process.env.PUBLIC_URL + '/images/dessert03.png',
    },
    {
        id: 75,
        category: '디저트',
        name: '아이스 마카롱 크림브륄레',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/dessert04.png',
    },
    {
        id: 76,
        category: '디저트',
        name: '버터 쿠키 샌드 바닐라 카라멜',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/dessert05.png',
    },
    {
        id: 77,
        category: '디저트',
        name: '베리 크럼블 스푼업',
        price: 6300,
        img: process.env.PUBLIC_URL + '/images/dessert06.png',
    },
    {
        id: 78,
        category: '디저트',
        name: '아이스 찹쌀 한과 흑임자',
        price: 6800,
        img: process.env.PUBLIC_URL + '/images/dessert07.png',
    },
    {
        id: 79,
        category: '디저트',
        name: '미니 아이스 스틱바 바닐라',
        price: 4800,
        img: process.env.PUBLIC_URL + '/images/dessert08.png',
    },
    {
        id: 80,
        category: '디저트',
        name: '맥심 스틱바 모카골드 마일드',
        price: 1600,
        img: process.env.PUBLIC_URL + '/images/dessert09.png',
    },
    {
        id: 81,
        category: '디저트',
        name: '스트로베리 버터 쿠키 샌드',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/dessert10.png',
    },
    {
        id: 82,
        category: '디저트',
        name: '골든 프랄렌 버터 쿠키 샌드',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/dessert11.png',
    },
    {
        id: 83,
        category: '디저트',
        name: '이즈니 버터 쿠키 샌드 세트 (4개입)',
        price: 17200,
        img: process.env.PUBLIC_URL + '/images/dessert12.png',
    },
    {
        id: 84,
        category: '디저트',
        name: '버터 쿠키 샌드 스트로베리',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/dessert13.png',
    },
    {
        id: 85,
        category: '디저트',
        name: '찹쌀 한과 선물 세트 (4개입)',
        price: 27200,
        img: process.env.PUBLIC_URL + '/images/dessert14.png',
    },
    {
        id: 86,
        category: '디저트',
        name: '아이스 쿠키 샌드 바닐라',
        price: 3800,
        img: process.env.PUBLIC_URL + '/images/dessert15.png',
    },
        {
        id: 87,
        category: '디저트',
        name: '아이스 찹쌀 한과 쌀',
        price: 6800,
        img: process.env.PUBLIC_URL + '/images/dessert16.png',
    },
    {
        id: 88,
        category: '디저트',
        name: '아몬드봉봉모찌',
        price: 3300,
        img: process.env.PUBLIC_URL + '/images/dessert17.png',
    },
    {
        id: 89,
        category: '디저트',
        name: '아이스 찹쌀 한과 고구마',
        price: 6800,
        img: process.env.PUBLIC_URL + '/images/dessert18.png',
    },
    {
        id: 90,
        category: '디저트',
        name: '아이스 모찌 크림치즈',
        price: 3300,
        img: process.env.PUBLIC_URL + '/images/dessert19.png',
    },
    {
        id: 91,
        category: '디저트',
        name: '맥심 스틱바 슈프림골드',
        price: 1600,
        img: process.env.PUBLIC_URL + '/images/dessert20.png',
    },
    {
        id: 92,
        category: '디저트',
        name: '아이스 모찌 그린티',
        price: 3300,
        img: process.env.PUBLIC_URL + '/images/dessert21.png',
    },
    {
        id: 93,
        category: '디저트',
        name: '아이스 모나카 우유',
        price: 3800,
        img: process.env.PUBLIC_URL + '/images/dessert22.png',
    },
    {
        id: 94,
        category: '디저트',
        name: '아이스 모찌 스트로베리',
        price: 3300,
        img: process.env.PUBLIC_URL + '/images/dessert23.png',
    },
    {
        id: 95,
        category: '디저트',
        name: '아이스 모찌 소금우유',
        price: 3300,
        img: process.env.PUBLIC_URL + '/images/dessert24.png',
    },
    {
        id: 96,
        category: '디저트',
        name: '아이스 마카롱 쿠키앤크림',
        price: 3800,
        img: process.env.PUBLIC_URL + '/images/dessert25.png',
    },
    {
        id: 97,
        category: '디저트',
        name: '아이스 모찌 초코바닐라',
        price: 3300,
        img: process.env.PUBLIC_URL + '/images/dessert26.png',
    },
    {
        id: 98,
        category: '디저트',
        name: '아이스 모나카 쫀떡 인절미',
        price: 3800,
        img: process.env.PUBLIC_URL + '/images/dessert27.png',
    },
    {
        id: 99,
        category: '음료',
        name: '미숫가루 라떼',
        price: 3800,
        img: process.env.PUBLIC_URL + '/images/juice01.png',
    },
    {
        id: 100,
        category: '음료',
        name: '버터팝콘쉐이크',
        price: 6300,
        img: process.env.PUBLIC_URL + '/images/juice02.png',
    },
    {
        id: 101,
        category: '음료',
        name: '설향딸기 블라스트',
        price: 4500,
        img: process.env.PUBLIC_URL + '/images/juice03.png',
    },
    {
        id: 102,
        category: '음료',
        name: '과일 허브 티 2종 (ICED)',
        price: 3500,
        img: process.env.PUBLIC_URL + '/images/juice04.png',
    },
    {
        id: 103,
        category: '음료',
        name: '짐빔 하이볼 레몬 블라스트',
        price: 5400,
        img: process.env.PUBLIC_URL + '/images/juice05.png',
    },
    {
        id: 104,
        category: '음료',
        name: '요거트 블라스트(스트로베리)',
        price: 4800,
        img: process.env.PUBLIC_URL + '/images/juice06.png',
    },
    {
        id: 105,
        category: '음료',
        name: '(Lessly Edition) 쉐이크',
        price: 4800,
        img: process.env.PUBLIC_URL + '/images/juice07.png',
    },
    {
        id: 106,
        category: '음료',
        name: '저당 과일티(레몬, 자몽)',
        price: 3500,
        img: process.env.PUBLIC_URL + '/images/juice08.png',
    },
    {
        id: 107,
        category: '음료',
        name: '과일 허브 티 2종 (HOT)',
        price: 3500,
        img: process.env.PUBLIC_URL + '/images/juice09.png',
    },
    {
        id: 108,
        category: '음료',
        name: '식혜 블라스트',
        price: 3800,
        img: process.env.PUBLIC_URL + '/images/juice10.png',
    },
    {
        id: 109,
        category: '음료',
        name: '딸기 연유 블라스트',
        price: 6800,
        img: process.env.PUBLIC_URL + '/images/juice11.png',
    },
    {
        id: 110,
        category: '음료',
        name: '딸기 찹쌀떡 쉐이크',
        price: 6700,
        img: process.env.PUBLIC_URL + '/images/juice12.png',
    },
    {
        id: 111,
        category: '음료',
        name: '아이스 믹스커피 블라스트',
        price: 4500,
        img: process.env.PUBLIC_URL + '/images/juice13.png',
    },
    {
        id: 112,
        category: '음료',
        name: '칸탈로프 멜론 블라스트',
        price: 5300,
        img: process.env.PUBLIC_URL + '/images/juice14.png',
    },
    {
        id: 113,
        category: '음료',
        name: '수박 블라스트',
        price: 5400,
        img: process.env.PUBLIC_URL + '/images/juice15.png',
    },
    {
        id: 114,
        category: '음료',
        name: '말차 쉐이크 2종',
        price: 6800,
        img: process.env.PUBLIC_URL + '/images/juice16.png',
    },
    {
        id: 115,
        category: '음료',
        name: '밀크 쉐이크',
        price: 5800,
        img: process.env.PUBLIC_URL + '/images/juice17.png',
    },
    {
        id: 116,
        category: '음료',
        name: '오레오 쉐이크(오리지널, 딸기, 초코)',
        price: 5800,
        img: process.env.PUBLIC_URL + '/images/juice18.png',
    },
    {
        id: 117,
        category: '음료',
        name: '납작복숭아 아이스티',
        price: 2000,
        img: process.env.PUBLIC_URL + '/images/juice19.png',
    },
    {
        id: 118,
        category: '음료',
        name: '와츄원 쉐이크',
        price: 5800,
        img: process.env.PUBLIC_URL + '/images/juice20.png',
    },
    {
        id: 119,
        category: '음료',
        name: '딸기 연유 라떼',
        price: 5300,
        img: process.env.PUBLIC_URL + '/images/juice21.png',
    },
    {
        id: 120,
        category: '음료',
        name: '카푸치노 블라스트(오리지널, 모카)',
        price: 5400,
        img: process.env.PUBLIC_URL + '/images/juice22.png',
    },
    {
        id: 121,
        category: '음료',
        name: '아이스크림 블라스트',
        price: 5800,
        img: process.env.PUBLIC_URL + '/images/juice23.png',
    },
    {
        id: 122,
        category: '카페',
        name: '콜드블루 라떼',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/cafe01.png',
    },
    {
        id: 123,
        category: '카페',
        name: '콜드블루 아메리카노',
        price: 3800,
        img: process.env.PUBLIC_URL + '/images/cafe02.png',
    },
    {
        id: 124,
        category: '카페',
        name: '콜드블루 오트',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/cafe03.png',
    },
    {
        id: 125,
        category: '카페',
        name: '아메리카노',
        price: 3200,
        img: process.env.PUBLIC_URL + '/images/cafe04.png',
    },
        {
        id: 126,
        category: '카페',
        name: '바닐라빈 라떼',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/cafe05.png',
    },
    {
        id: 127,
        category: '카페',
        name: '미샷추',
        price: 4500,
        img: process.env.PUBLIC_URL + '/images/cafe06.png',
    },
    {
        id: 128,
        category: '카페',
        name: '연유라떼',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/cafe07.png',
    },
    {
        id: 129,
        category: '카페',
        name: '카페라떼',
        price: 3800,
        img: process.env.PUBLIC_URL + '/images/cafe08.png',
    },
    {
        id: 130,
        category: '카페',
        name: '슈크림 아포가토 블라스트',
        price: 5800,
        img: process.env.PUBLIC_URL + '/images/cafe09.png',
    },
    {
        id: 131,
        category: '카페',
        name: '아포가토 라떼',
        price: 5000,
        img: process.env.PUBLIC_URL + '/images/cafe10.png',
    },
    {
        id: 132,
        category: '카페',
        name: '슈가밤 커피',
        price: 3900,
        img: process.env.PUBLIC_URL + '/images/cafe11.png',
    },
    {
        id: 133,
        category: '카페',
        name: '카페31',
        price: 5300,
        img: process.env.PUBLIC_URL + '/images/cafe12.png',
    },
    {
        id: 134,
        category: '카페',
        name: '엄마는 외계인 카페모카',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/cafe13.png',
    },
    {
        id: 135,
        category: '카페',
        name: '카라멜 마끼아또',
        price: 4300,
        img: process.env.PUBLIC_URL + '/images/cafe14.png',
    },
    {
        id: 136,
        category: '카페',
        name: '초코 스모어 라떼',
        price: 4800,
        img: process.env.PUBLIC_URL + '/images/cafe15.png',
    },
    {
        id: 137,
        category: '카페',
        name: '슈가밤 블라스트',
        price: 4000,
        img: process.env.PUBLIC_URL + '/images/cafe16.png',
    },
    {
        id: 138,
        category: '카페',
        name: '아포가토',
        price: 5800,
        img: process.env.PUBLIC_URL + '/images/cafe17.png',
    },
]

export default menu;